import { render, staticRenderFns } from "./ProRiskList.vue?vue&type=template&id=24a39b9f&scoped=true&"
import script from "./ProRiskList.vue?vue&type=script&lang=ts&"
export * from "./ProRiskList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a39b9f",
  null
  
)

export default component.exports